// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OzKE9","importantInfo":"styles_importantInfo__3N-_0"};